import AmountInput from 'components/AmountInput'
import CustomButton from 'components/Buttons/CustomButton'
import PMBProjectSelections from 'components/PMBProjectSelections'
import PMBSelect from 'components/PMBSelect'
import { itemUnitList } from 'constants'
import { formatNumber } from 'helpers'
import { useEffect, useState } from 'react'
import { Info, X } from 'react-feather'
import { Input, Modal } from 'reactstrap'
import { default as Text } from '../../../../../components/Text/index'
import UploadImageCard from '../Card/UploadImageCard'
import InventoryCodeInput from '../Input/InventoryCodeInput'
import { newFormatThousandSeparator } from 'utils/formatNumber'

export default function MergeInventoryModal({
  isOpen,
  selectedInventoryList,
  dataStock,
  onClose,
  items,
  onChangeDataStock,
  onSelectItem,
  onChangeAmount,
  onSelectItemUnit,
  onMergeStock,
  loading,
  selectedUnit,
  displayAmount,
  setDisplayAmount,
}) {
  const [isButtonDisabled, setButtonDisabled] = useState(false)
  const [selectedProject, setSelectedProject] = useState(null)

  useEffect(() => {
    if (
      dataStock?.amount &&
      dataStock?.linkFoto &&
      dataStock?.itemId &&
      dataStock.unit
    ) {
      setButtonDisabled(false)
    } else {
      setButtonDisabled(true)
    }
  }, [dataStock])

  useEffect(() => {
    if (!isOpen) {
      setSelectedProject(null)
    } else {
      const totalAmount = selectedInventoryList?.reduce(
        (total, item) => total + (item?.amount || 0),
        0,
      )
      const totalBundle = selectedInventoryList?.reduce(
        (total, item) => total + (item?.bundle || 1),
        0,
      )
      setDisplayAmount(String(newFormatThousandSeparator(totalAmount)))
      if (totalBundle && !dataStock?.bundle) {
        onChangeDataStock('bundle', totalBundle)
      }
    }
  }, [isOpen])

  return (
    <Modal isOpen={isOpen} centered>
      <div
        className="d-flex align-items-center"
        style={{
          padding: 20,
          borderBottom: '1px solid #EAECF0',
          justifyContent: 'space-between',
        }}
      >
        <Text bold size="medium">
          Penggabungan
        </Text>
        <div style={{ cursor: 'pointer' }} onClick={onClose}>
          <X />
        </div>
      </div>
      <div
        style={{
          paddingTop: 20,
          paddingLeft: 20,
          paddingRight: 20,
          display: 'flex',
          alignItems: 'center',
          gap: 4,
        }}
      >
        <Info size={16} className="text-danger-700" />
        <Text className="text-danger-700">
          Penggabungan tidak dapat dibatalkan
        </Text>
      </div>
      <div style={{ padding: 20, display: 'flex', gap: 8, overflowX: 'auto' }}>
        {selectedInventoryList?.map((el, i) => {
          return (
            <div
              key={i}
              style={{
                backgroundColor: '#f9fafb',
                padding: 10,
                borderRadius: 8,
                width: 150,
                minWidth: 150,
                flexShrink: 0,
              }}
            >
              <Text>{el?.item?.nameItem}</Text>
              <Text size="regular" color={'#667085'}>
                {newFormatThousandSeparator(el?.amount)} {el?.unit}
                {el?.bundle ? ` | ${el.bundle} Bundle` : ''}
              </Text>
              {el?.ownerCode ? (
                <Text color={'#667085'}>{el?.item?.nameItem}</Text>
              ) : null}
            </div>
          )
        })}
      </div>
      <div
        style={{
          paddingLeft: 20,
          paddingRight: 20,
          paddingBottom: 20,
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Text color={'#667085'}>
          Total Stok:{' '}
          <span style={{ fontWeight: 'bold' }}>
            {newFormatThousandSeparator(
              selectedInventoryList?.reduce(
                (total, item) => total + (item?.amount || 0),
                0,
              ),
            )}{' '}
            {selectedInventoryList?.[0]?.unit}
          </span>
        </Text>
        <Text color={'#667085'}>
          Total Bundle:{' '}
          <span style={{ fontWeight: 'bold' }}>
            {selectedInventoryList?.reduce(
              (total, item) => total + (item?.bundle || 1),
              0,
            )}
          </span>
        </Text>
      </div>
      <div style={{ padding: 20, borderTop: '1px solid #EAECF0' }}>
        <div>
          <Text className="no-padding">Kode inventori (opsional)</Text>
          <InventoryCodeInput
            value={dataStock?.ownerCode || ''}
            onChange={(text) => onChangeDataStock('ownerCode', text)}
            isAutoFocus
          />
        </div>
        <div className="mt-4">
          <Text className="no-padding">
            Barang
            <span style={{ color: '#b42218' }}>*</span>
          </Text>
          <div className="mt-2 w-100">
            <PMBSelect
              style={{ borderColor: 'white', caretColor: 'transparent' }}
              className="border-input button w-100"
              placeholder="Pilih barang"
              options={items?.map((el) => ({
                value: el.nameItem?.toLowerCase(),
                label: el.nameItem,
                ...el,
              }))}
              onChange={(selectedItem) => onSelectItem(selectedItem)}
            />
          </div>
        </div>
        <div className="mt-4">
          <Text className="no-padding">Project (opsional)</Text>
          <div className="mt-2 w-100">
            <PMBProjectSelections
              style={{ borderColor: 'white', caretColor: 'transparent' }}
              className="border-input button w-100"
              placeholder="Pilih project"
              value={selectedProject}
              onChange={(project) => setSelectedProject(project)}
            />
          </div>
        </div>
        {dataStock?.nameItem ? (
          <div className="mt-4">
            <UploadImageCard
              onChangeDataStock={onChangeDataStock}
              uploadedImage={dataStock?.linkFoto}
            />
          </div>
        ) : null}
        <div className="mt-4">
          <div className="d-flex justify-content-between">
            <div style={{ width: '49%' }}>
              <Text className="no-padding">
                Jumlah<span style={{ color: '#b42218' }}>*</span>
              </Text>
              <div className="mt-2 d-flex justify-content-between align-items-center">
                <AmountInput
                  name="quantity"
                  style={{ padding: 8 }}
                  cb={(e) =>
                    onChangeAmount('amount', e, onChangeDataStock, dataStock)
                  }
                  placeholder="Masukkan jumlah"
                  value={displayAmount || ''}
                />
              </div>
            </div>
            <div style={{ width: '49%' }}>
              <Text className="no-padding">
                Satuan<span style={{ color: '#b42218' }}>*</span>
              </Text>
              <div className="mt-2 w-100">
                <PMBSelect
                  options={itemUnitList?.map((el) => ({
                    value: el.title?.toLowerCase(),
                    label: el.title,
                    ...el,
                  }))}
                  style={{ borderColor: 'white', caretColor: 'transparent' }}
                  className="border-input button w-100"
                  placeholder="Pilih satuan"
                  value={
                    selectedUnit?.id
                      ? selectedUnit
                      : { value: dataStock?.unit, label: dataStock?.unit }
                  }
                  onChange={(unit) => onSelectItemUnit(unit)}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4">
          <Text className="no-padding">Bundle (opsional)</Text>
          <div className="bordered mt-2 d-flex justify-content-between align-items-center">
            <Input
              style={{ borderColor: 'white' }}
              value={dataStock?.bundle ?? ''}
              name="bundle"
              placeholder="Masukkan jumlah bundle"
              onChange={(e) => {
                const val = e.target.value?.replace(/[^\d]/g, '')
                onChangeDataStock('bundle', val ? Number(val) : '')
              }}
            />
          </div>
        </div>
        <div className="mt-4">
          <Text className="no-padding">Catatan tambahan (opsional)</Text>
          <div className="d-flex align-items-center">
            <div className="bordered mt-2" style={{ width: '100%' }}>
              <Input
                style={{ borderColor: 'white', height: 120 }}
                className="border-input"
                type="textarea"
                placeholder="Masukkan catatan jika ada..."
                onChange={(text) =>
                  onChangeDataStock('description', text.target.value)
                }
              />
            </div>
          </div>
        </div>
        <div className="mt-4">
          <CustomButton
            onClick={() => onMergeStock(selectedProject)}
            disabled={isButtonDisabled || loading}
            style={{
              backgroundColor: '#006386',
              fontSize: 14,
              width: '100%',
            }}
            className="fw-semibold"
          >
            Selesai
          </CustomButton>
        </div>
      </div>
    </Modal>
  )
}
